module.exports = __webpack_public_path__ + "static/media/sunset_9.c2437521.webp";